import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ActionButton } from '@/components/ui+/ActionButton';

const VirtualPinPadPage = () => {
  const { id } = Route.useParams();

  return (
    <div>
      <div className="mb-4">
        <ActionButton variant="outline" size="sm">
          <Link to="/a/linkly/devices/$id" params={{ id }}>
            Back to Device
          </Link>
        </ActionButton>
      </div>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Virtual PIN Pad</CardTitle>
        </CardHeader>
        <CardContent>...</CardContent>
      </Card>
    </div>
  );
};

export const Route = createFileRoute('/a/linkly/devices/$id/virtual-pin-pad')({
  component: VirtualPinPadPage,
});
